/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Group, Modal, Text } from "@mantine/core";
import { put } from "aws-amplify/api";
import {
  fetchAuthSession,
  getCurrentUser,
  GetCurrentUserOutput
} from "aws-amplify/auth";
import { useState } from "react";
import { appShowNotification } from "../../utils/utils";
type editPatientProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  patient: any;
  fetchPatients: () => void;
};

const ConfirmDeletePatientModal = (props: editPatientProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { modalOpened, setModalOpened, patient, fetchPatients } = props;
  const deletePatientRequest = async () => {
    setIsLoading(true);
    const user: GetCurrentUserOutput = await getCurrentUser();
    const { identityId } = await fetchAuthSession();

    const init: any = {
      response: true,
      headers: {},
      body: {
        patient: patient,
        username: user.username,
        userIdentityId: identityId
      }
    };
    try {
      const deletePatientResult = put({
        apiName: "DeletePatient",
        path: `/patient/${patient.id}`,
        options: init
      });
      await deletePatientResult.response;
      setModalOpened(false);
      setErrorMsg("");
      fetchPatients();
      appShowNotification({
        title: "Patient deleted successfully!",
        type: "success"
      });
    } catch (err: any) {
      console.log(err);
      // setErrorMsg(err.message);
      console.log(err);

      appShowNotification({
        title: "Failed to delete!",
        type: "error"
      });
    }
    setIsLoading(false);
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setErrorMsg("");
        setModalOpened(false);
      }}
      title="Delete patient"
    >
      <Box>
        <Text fw={400} fz={14}>
          Are you sure you want to delete this patient?
        </Text>
        {errorMsg && (
          <Text fw={400} fz={14} c="red">
            {errorMsg}
          </Text>
        )}
      </Box>
      <Group mt="md">
        <Group mt="md">
          <Button variant="default" onClick={() => setModalOpened(false)}>
            No
          </Button>
          <Button loading={isLoading} onClick={() => deletePatientRequest()}>
            Yes
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default ConfirmDeletePatientModal;
